'use strict';

var formWidget = require('form-widget-2.0.0');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');

var formWidgetInstance;

var triggerPromoFormMutationEvent = function() {

	triggerCustomEvent('promo-form-mutation', {
		target: appDom.promo
	});

};

var flagAsSubmissionComplete = function() {

	appDom.formWidget.closest('.promo__form-container').addClass('promo__form-container--submission-complete');

};

var onFormSubmissionBlocked = function(e, data) {

	formWidgetInstance.form.html(data.markup);
	flagAsSubmissionComplete();
	triggerPromoFormMutationEvent();

};

var onFormSubmissionSuccess = function(e, data) {

	triggerCustomEvent('promo-form-submission-success', {
		target: appDom.promo
	});

	formWidgetInstance.showSubmission(data.paymentReceiptUrl, data.documentViewUrl);
	flagAsSubmissionComplete();

};

// var onFormClick = function() {

// 	triggerCustomEvent('promo-form-clicked', {
// 		target: appDom.promo
// 	});

// };

var init = function() {

	if (appDom.formWidget.length) {

		appDom.formWidget.attr('id', 'fbForm');

		formWidgetInstance = formWidget.create('fbForm', {
			forceOneColMode: true,
			notifyContainer: 'target',
			notifyScrollContainer: '.promo__layout',
			icons: {
				base: 'promo-icon'
			}
		});

		formWidgetInstance.form
			.on('fbWidget-mutation', triggerPromoFormMutationEvent)
			.on('fbWidget-form-expired fbWidget-form-at-submission-limit', onFormSubmissionBlocked)
			.on('fbWidget-form-submit-success', onFormSubmissionSuccess);
			// .on('click', onFormClick);

	}

};

module.exports = {
	init: init
};
